import { render, staticRenderFns } from "./Favourites.vue?vue&type=template&id=0bd28e9a&scoped=true"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"
import style0 from "./Favourites.vue?vue&type=style&index=0&id=0bd28e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd28e9a",
  null
  
)

export default component.exports